export const LOAD_COMPANY = "Company/LOAD_COMPANY";
export const LOAD_COMPANY_SUCCESS = "Company/LOAD_COMPANY_SUCCESS";
export const LOAD_COMPANY_ERROR = "Company/LOAD_COMPANY_ERROR";
